import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {downloadFile} from '../../../exportUtils';
import {DeleteDialogComponent} from '../delete-dialog/delete-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {ExportService} from '../../services/export.service';
import {environment} from '../../../environments/environment';
import {DashboardService} from '../../services/dashboard.service';
import {StudyProgrammeDto, StudyProgrammeReqFormOfStudy} from '../../modules/forms/modules/sp/models/osp';
import {HabilitationInaugurationDto} from '../../modules/forms/modules/hip/models/hip';
import {Vtc} from '../../modules/forms/modules/vtc/models/vtc';
import {TranslateService} from '@ngx-translate/core';
import {Announcement} from '../../models/announcement';
import {AnnouncementService} from '../../services/announcement.service';
import {User} from '../../models/user';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute, Router, NavigationEnd} from '@angular/router';
import {first} from 'rxjs/operators';
import {marker} from '@biesbjerg/ngx-translate-extract-marker';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, AfterViewInit {
  public uuid = localStorage.getItem('uuid');
  public bottomPartHeight = 0;
  public production: boolean;

  public studyProgrammes: StudyProgrammeDto[];
  public spSearch: string;
  public isSearchingSp = false;
  public spFilterMetadata = {count: 0};

  public state = [
    {value: 1, displayValue: marker('forms.osp.tabs.basic_data.section.basic_data.state.open')},
    {value: -1, displayValue: marker('forms.osp.tabs.basic_data.section.basic_data.state.closed')},
    {value: 0, displayValue: marker('forms.osp.tabs.basic_data.section.basic_data.state.new')}
  ];
  public isFiltering = false;
  public stateFormHolder: StudyProgrammeDto = {
        idStudyProgramme: 21109,
        title: 'informatika',
        degree: 1,
        studyField: 'informatika',
        studyField2: '',
        guaranteesCount: 5,
        formOfStudy: StudyProgrammeReqFormOfStudy.PRESENT,
        faculty: {
          idDepartment: 1040,
          acronym: 'FEI',
          name: 'Fakulta elektrotechniky a informatiky',
          nameEn: 'Faculty of Electrical Engineering and Informatics',
          color: '#EAAA00',
          web: 'http://fei.tuke.sk'
        },
        state: -1,
        stateText: 'Zrušený'
      };


  public hips: HabilitationInaugurationDto[];
  public hipSearch: string;
  public hipFilterMetadata = {count: 0};
  public isSearchingHip = false;

  public vtcs: Vtc[];
  public vtcSearch: string;
  public vtcFilterMetadata = {count: 0};
  public isSearchingVTC = false;

  announcements: Announcement[] = [];
  currentUser: User;

  @ViewChild('searchInput') searchInputElement: ElementRef;
  @ViewChild('filterInput') filterInputElement: ElementRef;
  @ViewChild('searchHipInput') searchHipInputElement: ElementRef;
  @ViewChild('searchVTCInput') searchVTCInputElement: ElementRef;
  @ViewChild('upperPart') upperPart: ElementRef;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private exportService: ExportService,
              private dashboardService: DashboardService,
              private announcementService: AnnouncementService,
              private http: HttpClient,
              private cdr: ChangeDetectorRef,
              private translate: TranslateService,
              public dialog: MatDialog) {
  }

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.setBottomPartHeight();
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.spSearch = params.spSearch || '';
      this.hipSearch = params.hipSearch || '';
      this.vtcSearch = params.vtcSearch || '';
      this.stateFormHolder.state = (params.state !== undefined && params.state !== null) ? +params.state : 1;

      this.isSearchingSp = !!this.spSearch;
      this.isSearchingHip = !!this.hipSearch;
      this.isSearchingVTC = !!this.vtcSearch;
    });

    // this.spSearch = '';
    this.getAnnouncements();
    this.getCurrentUser();
  }

  ngAfterViewInit(): void {
    this.production = environment.production;
    setTimeout(() => {
      if (environment.production || environment.development) {
      this.dashboardService.getStudyProgrammes().then((studyProgrammes: StudyProgrammeDto[]) => {
        this.studyProgrammes = studyProgrammes;
      });
      this.dashboardService.getHKIKs().then((hips: HabilitationInaugurationDto[]) => {
        this.hips = hips;
      });
      }
      this.dashboardService.getVTCsForUser(+this.uuid).then((vtcs: Vtc[]) => {
        this.vtcs = vtcs;
        console.log(vtcs);
        this.cdr.detectChanges();
      });
    }, 500);
    if (!environment.production && !environment.development) {
      this.dashboardService.getStudyProgrammes().then((studyProgrammes: StudyProgrammeDto[]) => {
        this.studyProgrammes = studyProgrammes;
      });
      //this.studyProgrammes = this.getSPList();
      this.hips = this.getHKIKLIst();
    }
    this.setBottomPartHeight();
    this.cdr.detectChanges();
  }

  public downloadVUPCH(): void {
    this.exportService.exportVupchForm(this.uuid).then(res => {
      downloadFile(res, 'VUPCH');
    });
  }

  public downloadVTC(uuid: any): void {
    this.exportService.exportVtcForm(uuid).then(res => {
      downloadFile(res, 'VTC');
    });
  }

  public toggleSearchingSp(isSearching: boolean): void {
    this.isSearchingSp = isSearching;
    if (isSearching) {
      setTimeout(() => {
        this.searchInputElement.nativeElement.focus();
      }, 100);
    } else {
      this.spSearch = '';
      this.router.navigate([], {
        queryParams: { spSearch: null },
        queryParamsHandling: 'merge',
      });
    }
  }

  public toggleFilter(isFiltering: boolean): void {
    this.isFiltering = isFiltering;
    if (!isFiltering) {
      this.router.navigate([], {
        queryParams: { state: 1 },
        queryParamsHandling: 'merge',
      });
    }
  }

  public toggleSearchingHip(isSearching: boolean): void {
    this.isSearchingHip = isSearching;
    if (isSearching) {
      setTimeout(() => {
        this.searchHipInputElement.nativeElement.focus();
      }, 100);
    } else {
      this.spSearch = '';
      this.router.navigate([], {
        queryParams: { hipSearch: null },
        queryParamsHandling: 'merge',
      });
    }
  }

  public toggleSearchingVTC(isSearching: boolean): void {
    this.isSearchingVTC = isSearching;
    if (isSearching) {
      setTimeout(() => {
        this.searchVTCInputElement.nativeElement.focus();
      }, 100);
    } else {
      this.vtcSearch = '';
      this.router.navigate([], {
        queryParams: { vtcSearch: null },
        queryParamsHandling: 'merge',
      });
    }
  }

  public deleteVTC(vtc: Vtc): void {

    const dialogRef = this.dialog.open(DeleteDialogComponent);
    const instance = dialogRef.componentInstance;
    instance.text = this.translate.instant('dialogs.delete_dialog.text.dashboard.vtc');

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dashboardService.deleteVTC(vtc).then(res => {
          this.vtcs = null;
          this.dashboardService.getVTCsForUser(+this.uuid).then((vtcs: Vtc[]) => {
            this.vtcs = vtcs;
          });
        });
      }
    });
  }

  private setBottomPartHeight(): void {
    this.bottomPartHeight = (window.innerHeight - (this.upperPart.nativeElement.offsetHeight) - 50); // cca 50px is .list-title height
    this.cdr.detectChanges();
  }

  private getSPList(): StudyProgrammeDto[] {
    return [
      {
        idStudyProgramme: 11587, //UI_Dok_D_sk 104950
        title: 'informatika',
        degree: 1,
        studyField: 'informatika',
        studyField2: '',
        guaranteesCount: 5,
        formOfStudy: StudyProgrammeReqFormOfStudy.PRESENT,
        faculty: {
          idDepartment: 1040,
          acronym: 'FEI',
          name: 'Fakulta elektrotechniky a informatiky',
          nameEn: 'Faculty of Electrical Engineering and Informatics',
          color: '#EAAA00',
          web: 'http://fei.tuke.sk',
        },
        state: 1,
      },
      {
        idStudyProgramme: 21109,
        title: 'informatika',
        degree: 1,
        studyField: 'informatika',
        studyField2: '',
        guaranteesCount: 5,
        formOfStudy: StudyProgrammeReqFormOfStudy.PRESENT,
        faculty: {
          idDepartment: 1040,
          acronym: 'FEI',
          name: 'Fakulta elektrotechniky a informatiky',
          nameEn: 'Faculty of Electrical Engineering and Informatics',
          color: '#EAAA00',
          web: 'http://fei.tuke.sk',
        },
        state: -1,
      },
    ];
  }

  private getHKIKLIst(): HabilitationInaugurationDto[] {
    return [
      {
        idHabilitationInauguration: 594990,
        title: 'informatika',
        studyField: 'informatika',
        studyField2: null,
        guaranteesCount: 5,
        faculty: {
          idDepartment: 1040,
          acronym: 'FEI',
          name: 'Fakulta elektrotechniky a informatiky',
          nameEn: 'Faculty of Electrical Engineering and Informatics',
          color: '#EAAA00',
          web: 'http://fei.tuke.sk'
        },
      }
    ];
  }

  private getAnnouncements(): void {
    this.announcementService.getDashboardAnnouncements().subscribe(res => {
      this.announcements = res;
    });
  }

  private getCurrentUser(): void {
    this.http.get(`${environment.api_url}/user`, {
      withCredentials: true
    }).subscribe((res: User) => {
      this.currentUser = res;
    });
  }

  isCurrentUserEvaluator(): boolean {
    return this.currentUser?.roles?.some(role => role.idRole === 1 || role.idRole === 4);
  }

  public onSearchChange(): void {
    if (this.spSearch && this.spSearch.trim() !== '') {
      this.router.navigate([], {
        queryParams: { spSearch: this.spSearch },
        queryParamsHandling: 'merge',
      });
    } else {
      this.router.navigate([], {
        queryParams: { spSearch: null },
        queryParamsHandling: 'merge',
      });
    }
  }

  public onFilterChange(): void {
    this.router.navigate([], {
      queryParams: { state: this.stateFormHolder.state },
      queryParamsHandling: 'merge',
    });
  }

  public onHipSearchChange(): void {
    if (this.hipSearch && this.hipSearch.trim() !== '') {
      this.router.navigate([], {
        queryParams: { hipSearch: this.hipSearch },
        queryParamsHandling: 'merge',
      });
    } else {
      this.router.navigate([], {
        queryParams: { hipSearch: null },
        queryParamsHandling: 'merge',
      });
    }
  }

  public onVtcSearchChange(): void {
    if (this.vtcSearch && this.vtcSearch.trim() !== '') {
      this.router.navigate([], {
        queryParams: { vtcSearch: this.vtcSearch },
        queryParamsHandling: 'merge',
      });
    } else {
      this.router.navigate([], {
        queryParams: { vtcSearch: null },
        queryParamsHandling: 'merge',
      });
    }
  }

  public getQueryParams(): any {
    return {
      ...(this.spSearch ? { spSearch: this.spSearch } : {}),
      ...(this.hipSearch ? { hipSearch: this.hipSearch } : {}),
      ...(this.vtcSearch ? { vtcSearch: this.vtcSearch } : {}),
      ...(this.stateFormHolder.state != 1 ? { state: this.stateFormHolder.state } : { state: 1 }),
    };
  }

  public getQueryParamsWithView(): any {
    return { view: true, ...this.getQueryParams() };
  }

}
